import React, { FC } from 'react';

import { LayoutProps } from '../layoutProps';
import Wrapper from '../Wrapper';
import Image from '../Image';
import { ExtraDetails } from './ExtraDetails';
import DetailsModal from './DetailsModal';

export const NarrowLayout: FC<LayoutProps> = ({
  imageUrl,
  featured,
  description,
  hideDetails,
  isShowingDetails,
  name,
  price,
  pricePerNight,
  showDetails,
  showPrice,
  isSelected,
  controls,
  pricingType,
  quantityLabel,
}) => (
  <Wrapper featured={featured} isSelected={isSelected}>
    {featured && <Image imageUrl={imageUrl} alt={name} isWiderViewport={false} featured />}
    <ExtraDetails
      description={description}
      featured={featured}
      hideDetails={hideDetails}
      isShowingDetails={isShowingDetails}
      name={name}
      price={price}
      pricePerNight={pricePerNight}
      showDetails={showDetails}
      showPrice={showPrice}
      controls={controls}
      pricingType={pricingType}
      quantityLabel={quantityLabel}
    />
    <DetailsModal
      isOpen={isShowingDetails}
      closeModal={hideDetails}
      imageUrl={imageUrl}
      name={name}
      description={description}
    />
  </Wrapper>
);
